/* ============================================================
   LOOKBOOK - LIVRE FEUILLETABLE
   ------------------------------------------------------------
   Initialise StPageFlip sur .lookbook-book.

   REPLI : si la bibliotheque n'a pas pu etre chargee (CDN
   injoignable, connexion coupee, bloqueur), on ne laisse PAS une
   page vide : le livre bascule en colonne verticale, qui reste
   parfaitement lisible avec des photos verticales. Les fleches
   sont alors masquees.
   ============================================================ */
(function () {
  'use strict';

  var ATTENTE_MAX = 6000; // ms avant d'abandonner et de basculer en repli
  var DEBUT = Date.now();

  function replier(livre) {
    livre.classList.add('lookbook-book--fallback');
  }

  /* Hauteur libre entre l'en-tete et le pied de page, moins ce que
     la page affiche deja autour du livre (titre / retour, fleches).
     On en deduit la hauteur d'une page, puis sa largeur via le
     format choisi dans la section. Si c'est la largeur de l'ecran
     qui limite, c'est elle qui l'emporte. */
  /* De la place pour le bas de page de la section et pour l'ombre
     portee du livre, qui deborde de la double page. */
  var MARGE_RESPIRATION = 52;

  /* Hauteur reellement disponible entre l'en-tete et le pied de page,
     posee sur la section pour que le CSS puisse y centrer le livre
     (voir .lookbook-series en mobile dans lookbook.css). */
  function publierHauteur(livre) {
    var section = livre.closest ? livre.closest('.lookbook-series') : null;
    if (!section) return;
    var entete = document.querySelector('.header-wrapper') || document.querySelector('header');
    var pied = document.querySelector('.footer') || document.querySelector('footer');
    var pris = (entete ? entete.offsetHeight : 0) + (pied ? pied.offsetHeight : 0);
    section.style.setProperty(
      '--lb-dispo',
      Math.max(300, window.innerHeight - pris) + 'px'
    );
  }

  /* Seuil mobile, le meme que dans lookbook.css. */
  function estEtroit() {
    return window.innerWidth <= 749;
  }

  function mesurer(livre) {
    var refLargeur = parseInt(livre.dataset.pageWidth, 10) || 380;
    var refHauteur = parseInt(livre.dataset.pageHeight, 10) || 560;
    var rapport = refLargeur / refHauteur;

    var entete = document.querySelector('.header-wrapper') || document.querySelector('header');
    var pied = document.querySelector('.footer') || document.querySelector('footer');
    var tete = document.querySelector('.lookbook-series__head');

    var pris =
      (entete ? entete.offsetHeight : 0) +
      (pied ? pied.offsetHeight : 0) +
      (tete ? tete.offsetHeight : 0) +
      MARGE_RESPIRATION;

    var hauteurLibre = Math.max(260, window.innerHeight - pris);

    var parent = livre.parentNode;
    /* clientWidth COMPREND les marges interieures de la section : sans
       les retrancher, le livre deborde de l'ecran sur mobile. */
    var reglesParent = parent ? getComputedStyle(parent) : null;
    var place = parent
      ? parent.clientWidth -
        (parseFloat(reglesParent.paddingLeft) || 0) -
        (parseFloat(reglesParent.paddingRight) || 0)
      : window.innerWidth;

    /* Ecran etroit : la double page doit occuper toute la largeur
       disponible, sinon le livre finit en timbre-poste au milieu d'un
       ecran vide. StPageFlip bornera chaque page a la moitie du bloc.

       Grand ecran : 2.5 et non 2, parce que le livre ferme se decale
       d'une demi-page pour rester centre (voir recentrer()). */
    var largeurLibre = estEtroit() ? place * 0.98 : place / 2.5;

    var hauteur = Math.min(hauteurLibre, largeurLibre / rapport, refHauteur * 1.6);

    return {
      hauteur: Math.round(hauteur),
      largeur: Math.round(hauteur * rapport)
    };
  }

  /* ============================================================
     PAGE AGRANDIE (double-clic)
     ------------------------------------------------------------
     Le piege : StPageFlip tourne une page a CHAQUE clic. Un
     double-clic en tourne donc deux pendant qu'on ouvre
     l'agrandissement, et tenter de l'annuler sur-le-champ ne
     marche pas : l'animation en cours reprend la main juste
     apres.

     On remet donc le livre en place a la FERMETURE, et non a
     l'ouverture : a ce moment plus aucune animation n'est en vol,
     turnToPage() est fiable, et le fond noir a cache tout le
     remue-menage. Bonus : si on a fait defiler les photos avec les
     fleches, le livre se rouvre sur la photo que l'on regardait.
     ============================================================ */

  function creerAgrandissement(livre, flip, pages, recentrer, enMouvement) {
    var boite = document.querySelector('[data-lookbook-zoom]');
    if (!boite) return;

    var image = boite.querySelector('[data-lookbook-zoom-image]');
    var prec = boite.querySelector('[data-lookbook-zoom-prev]');
    var suiv = boite.querySelector('[data-lookbook-zoom-next]');
    var fermer = boite.querySelector('[data-lookbook-zoom-close]');

    /* Liste des photos, dans l'ordre du livre, avec le numero de la
       page qui les porte. La quatrieme de couverture (le logo) n'en
       fait pas partie : il n'y a rien a agrandir.
       On parcourt "pages", releve AVANT que StPageFlip ne reorganise
       le DOM : c'est la seule source sure de l'ordre de lecture. */
    var photos = [];
    for (var i = 0; i < pages.length; i++) {
      var photo = pages[i].querySelector('.lookbook-book__image');
      if (!photo) continue;
      photos.push({
        element: photo,
        page: i,
        src: photo.currentSrc || photo.src,
        alt: photo.alt || ''
      });
    }
    if (!photos.length) return;

    var position = 0;

    /* LARGEUR DEMANDEE POUR LE PLEIN ECRAN.
       On demandait 1800 px partout. Sur un telephone l'image affichee
       fait au mieux 375 px de large : meme en tenant compte de la
       densite d'ecran, 1200 suffit, et le fichier est deux fois plus
       leger - d'ou une attente deux fois plus courte.
       La photo est au format portrait : sa largeur a l'ecran est donc
       bornee par la HAUTEUR disponible, pas seulement par la largeur
       de la fenetre. */
    var PALIERS = [800, 1000, 1200, 1500, 1800];

    function largeurPleinEcran() {
      var densite = window.devicePixelRatio || 1;
      var affichee = Math.min(window.innerWidth, window.innerHeight * 0.72);
      var besoin = affichee * densite;
      for (var i = 0; i < PALIERS.length; i++) {
        if (PALIERS[i] >= besoin) return PALIERS[i];
      }
      return 1800;
    }

    function grandeVersion(src) {
      if (!src) return src;
      if (/[?&]width=\d+/.test(src)) {
        return src.replace(/([?&]width=)\d+/, '$1' + largeurPleinEcran());
      }
      return src;
    }

    function afficher(n) {
      if (n < 0 || n >= photos.length) return;
      position = n;

      var photo = photos[n];
      /* La version affichee dans le livre est DEJA dans le cache du
         navigateur. On la montre donc tout de suite, puis on la
         remplace par la grande des qu'elle est arrivee. Avant, on
         demandait directement la grande et l'ecran restait noir
         pendant tout le telechargement. */
      var petite = photo.element.currentSrc || photo.src;
      var grande = grandeVersion(photo.src);

      image.removeAttribute('srcset');
      image.alt = photo.alt;
      image.src = petite;
      image.style.opacity = '1';

      if (grande && grande !== petite) {
        var attendue = new Image();
        attendue.onload = function () {
          /* On a pu changer de photo entre-temps : on ne colle pas
             une image en retard par-dessus celle qu'on regarde. */
          if (position !== n) return;
          image.src = grande;
        };
        attendue.src = grande;
      }

      if (prec) prec.disabled = n === 0;
      if (suiv) suiv.disabled = n === photos.length - 1;
    }

    function ouvrir(n) {
      afficher(n);
      boite.classList.add('lookbook-zoom--ouvert');
      boite.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function refermer() {
      boite.classList.remove('lookbook-zoom--ouvert');
      boite.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';

      /* Le livre se place sur la photo que l'on vient de regarder.
         Sans effet si on n'a pas touche aux fleches ; utile si on a
         fait defiler les photos, le livre se rouvre alors au bon
         endroit. */
      try { flip.turnToPage(photos[position].page); } catch (e) {}
      /* turnToPage n'emet pas d'evenement "flip" : on remesure nous-memes. */
      if (recentrer) setTimeout(function () { recentrer(true); }, 30);
    }

    function estOuvert() {
      return boite.classList.contains('lookbook-zoom--ouvert');
    }

    /* --- Clic simple : tourner. Double-clic : agrandir. ---
       Le clic simple attend DELAI_DOUBLE millisecondes avant de
       tourner la page. Si un second clic arrive entre-temps, on
       annule le tournage et on agrandit : le livre ne bouge pas
       d'un pouce pendant le double-clic. */
    /* AU DOIGT ON EST PLUS LENT QU'A LA SOURIS. Deux tapes humaines
       sont separees de 250 a 400 ms, la ou deux clics de souris
       tiennent dans 150 ms. Avec une fenetre de 230 ms la premiere
       tape tournait la page avant que la seconde arrive : le
       double-tap ne faisait jamais rien. Le doigt se deplace aussi
       davantage entre les deux, d'ou la tolerance en pixels. */
    var AU_DOIGT = window.matchMedia
      ? window.matchMedia('(pointer: coarse)').matches
      : false;
    var DELAI_DOUBLE = AU_DOIGT ? 330 : 230;
    var ECART_MAX = AU_DOIGT ? 60 : 24;
    var minuterieClic = null;
    var dateDernierClic = 0;
    var xDernierClic = 0;
    var yDernierClic = 0;

    /* AVANCE-T-ON ? On ne se fie pas au centre du BLOC : livre ferme,
       ou en mode portrait (mobile), le bloc reserve la place de deux
       pages alors qu'une seule est dessinee, et son centre tombe a
       cote. On mesure donc les pages reellement dessinees.
       Quand il n'y en a qu'une - mobile, ou couverture - un doigt pose
       n'importe ou avance ; seul le premier quart fait reculer. */
    function versLaSuite(x) {
      var items = livre.querySelectorAll('.stf__item');
      var gauche = Infinity;
      var droite = -Infinity;
      var largeurPage = 0;

      for (var i = 0; i < items.length; i++) {
        if (getComputedStyle(items[i]).display === 'none') continue;
        var r = items[i].getBoundingClientRect();
        if (!r.width) continue;
        if (r.left < gauche) gauche = r.left;
        if (r.right > droite) droite = r.right;
        if (r.width > largeurPage) largeurPage = r.width;
      }

      if (!largeurPage) {
        var cadre = livre.getBoundingClientRect();
        return x >= cadre.left + cadre.width / 2;
      }

      if (droite - gauche < largeurPage * 1.5) {
        return x > gauche + largeurPage * 0.25;
      }
      return x >= (gauche + droite) / 2;
    }

    /* Agrandit la page touchee. Rend faux s'il n'y a rien a agrandir
       (quatrieme de couverture, page blanche, bord du livre). */
    function agrandirDepuis(cible) {
      var page = cible && cible.closest && cible.closest('.lookbook-book__page');
      if (!page) return false;
      var photo = page.querySelector('.lookbook-book__image');
      if (!photo) return false;
      for (var i = 0; i < photos.length; i++) {
        if (photos[i].element === photo) { ouvrir(i); return true; }
      }
      ouvrir(0);
      return true;
    }

    /* Horodatage pose par le filet tactile ci-dessous : le "click"
       de synthese qui suit la seconde tape ne doit pas tourner une
       page par-dessus l'agrandissement qui vient de s'ouvrir. */
    var clicAIgnorer = 0;

    livre.addEventListener('click', function (event) {
      if (estOuvert()) return;
      if (clicAIgnorer && Date.now() - clicAIgnorer < 700) return;

      var maintenant = Date.now();
      /* DOUBLE-TAP : on le detecte nous-memes, a l'horodatage. Au doigt
         "event.detail" vaut 1 aux deux coups et l'evenement dblclick
         n'est pas emis partout : s'y fier laissait le mobile sans
         agrandissement. */
      var memeEndroit =
        Math.abs(event.clientX - xDernierClic) < ECART_MAX &&
        Math.abs(event.clientY - yDernierClic) < ECART_MAX;

      if (minuterieClic && memeEndroit && maintenant - dateDernierClic < DELAI_DOUBLE) {
        clearTimeout(minuterieClic);
        minuterieClic = null;
        dateDernierClic = 0;
        event.preventDefault();
        agrandirDepuis(event.target);
        return;
      }

      dateDernierClic = maintenant;
      xDernierClic = event.clientX;
      yDernierClic = event.clientY;

      if (minuterieClic) clearTimeout(minuterieClic);

      var avance = versLaSuite(event.clientX);

      var indexAuClic = null;
      try { indexAuClic = flip.getCurrentPageIndex(); } catch (e) {}

      minuterieClic = setTimeout(function () {
        minuterieClic = null;
        try {
          /* DEUX PAGES D'UN COUP : un clic un peu glisse est pris par la
             bibliotheque pour un debut de glissement, et elle tourne la
             page elle-meme. Notre tournage s'ajoutait au sien. Si la
             page a change depuis le clic, ou si quelque chose bouge
             encore, on ne fait rien. */
          if (enMouvement && enMouvement()) return;
          if (indexAuClic !== null && flip.getCurrentPageIndex() !== indexAuClic) return;

          if (avance) flip.flipNext();
          else flip.flipPrev();
        } catch (e) {}
      }, DELAI_DOUBLE);
    });

    /* FILET AU DOIGT.
       Selon le navigateur, le second "click" d'un double-tap peut ne
       jamais arriver : la bibliotheque gere elle-meme le toucher pour
       le glissement du coin et avale parfois l'evenement. On ecoute
       donc aussi touchend, qui part toujours, et en phase de capture
       pour passer avant elle. */
    if (AU_DOIGT) {
      var dateTape = 0;
      var xTape = 0;
      var yTape = 0;

      livre.addEventListener(
        'touchend',
        function (event) {
          if (estOuvert()) return;
          var doigt = event.changedTouches && event.changedTouches[0];
          if (!doigt) return;

          var maintenant = Date.now();
          var seconde =
            dateTape &&
            maintenant - dateTape < DELAI_DOUBLE &&
            Math.abs(doigt.clientX - xTape) < ECART_MAX &&
            Math.abs(doigt.clientY - yTape) < ECART_MAX;

          if (seconde) {
            dateTape = 0;
            if (minuterieClic) {
              clearTimeout(minuterieClic);
              minuterieClic = null;
            }
            dateDernierClic = 0;
            clicAIgnorer = maintenant;
            agrandirDepuis(doigt.target || event.target);
            return;
          }

          dateTape = maintenant;
          xTape = doigt.clientX;
          yTape = doigt.clientY;
        },
        { capture: true, passive: true }
      );
    }

    /* --- Fermeture et navigation --- */
    if (fermer) fermer.addEventListener('click', refermer);
    if (prec) prec.addEventListener('click', function () { afficher(position - 1); });
    if (suiv) suiv.addEventListener('click', function () { afficher(position + 1); });

    /* LE DOUBLE-CLIC SUR LA PHOTO AGRANDIE NE FAIT RIEN.
       Arrive ici, il n'y a plus rien a agrandir. On l'arrete donc net,
       pour que ni le navigateur (son propre zoom) ni le livre en
       dessous ne s'en saisissent. Le CSS fait sa part au doigt avec
       touch-action; ceci couvre la souris. */
    boite.addEventListener('dblclick', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    // Clic sur le fond (et non sur l'image ou les boutons) : on ferme.
    boite.addEventListener('click', function (event) {
      if (event.target === boite || event.target.classList.contains('lookbook-zoom__media')) refermer();
    });

    document.addEventListener('keydown', function (event) {
      if (!estOuvert()) return;
      if (event.key === 'Escape') refermer();
      if (event.key === 'ArrowLeft') afficher(position - 1);
      if (event.key === 'ArrowRight') afficher(position + 1);
    });

    return { estOuvert: estOuvert };
  }

  function demarrer(livre) {
    var pages = livre.querySelectorAll('.lookbook-book__page');
    if (!pages.length) return;

    /* Le format de page vient du reglage de la section ; la TAILLE
       reelle, elle, vient de la place disponible a l'ecran : le
       livre doit tenir en entier, pied de page compris, sans
       jamais faire defiler la page. */
    publierHauteur(livre);

    var format = mesurer(livre);
    var largeur = format.largeur;
    var hauteur = format.hauteur;

    /* StPageFlip en mode 'stretch' prend la largeur du parent : on la
       borne a la double page calculee - a la page simple sur mobile,
       ou une seule est dessinee. */
    livre.style.maxWidth = largeur * 2 + 'px';
    /* Le titre de couverture se dimensionne dessus (lookbook.css). */
    livre.style.setProperty('--page-largeur', largeur + 'px');

    var flip;
    try {
      flip = new window.St.PageFlip(livre, {
        width: largeur,
        height: hauteur,
        size: 'stretch',
        /* Bornes calculees plus haut : le livre reste un objet qu'on
           tient dans les mains, et ne depasse jamais l'ecran. */
        /* minWidth decide aussi de l'orientation : la bibliotheque
           passe en page simple quand le bloc est plus etroit que deux
           fois cette valeur. On la laisse basse pour garder la DOUBLE
           PAGE partout, mobile compris : un livre ouvert doit montrer
           ses deux pages. */
        minWidth: 170,
        maxWidth: largeur,
        minHeight: 250,
        maxHeight: hauteur,
        showCover: true,
        maxShadowOpacity: 0.4,
        flippingTime: 800,   /* vitesse du tournage de page */
        usePortrait: true,          /* une seule page sur ecran etroit */
        mobileScrollSupport: false,
        drawShadow: true,
        /* ON COUPE LE CLIC DE LA BIBLIOTHEQUE.
           Sinon elle tourne une page a chaque clic, et un double-clic
           en tourne deux avant qu'on ait pu reagir : le livre partait
           en avant au lieu d'agrandir la page. Le clic est donc gere
           plus bas, par nous, avec une courte attente qui laisse le
           temps au second clic d'arriver. Le glissement du coin, lui,
           n'est pas touche. */
        disableFlipByClick: true
      });
      flip.loadFromHTML(pages);
    } catch (e) {
      replier(livre);
      return;
    }

    /* Le livre reste invisible (visibility: hidden, voir lookbook.css)
       tant qu'il n'est pas centre : sans cela on le voyait apparaitre
       a droite puis sauter au centre au chargement. */
    function marquerPret() {
      livre.classList.add('lookbook-book--ready');
    }

    /* Filet de securite : si le centrage n'aboutit jamais (mesure
       impossible, bibliotheque dans un etat inattendu), le livre
       s'affiche quand meme plutot que de rester invisible. */
    setTimeout(marquerPret, 1500);

    /* ============================================================
       LIVRE FERME = LIVRE CENTRE
       ------------------------------------------------------------
       StPageFlip reserve toujours la largeur de DEUX pages. Livre
       ferme, une seule est dessinee — a droite pour la premiere de
       couverture, a gauche pour le dos — et le livre parait decale.

       Plutot que de deviner l'etat a partir des index (fragile : la
       bibliotheque numerote differemment selon l'orientation et le
       mode couverture), on MESURE ce qui est reellement dessine et on
       deplace le bloc de l'ecart constate. Le calcul se corrige donc
       tout seul, et marche aussi bien a la couverture, au dos, en
       double page qu'en mode portrait.
       ============================================================ */
    var decalageApplique = null;
    var derniereAgitation = 0;   // horodatage du dernier mouvement de page
    var minuterieRecentrage = null;

    /* Est-on en train de bouger ? On repond avec un HORODATAGE et non
       avec un drapeau : un drapeau qu'on oublie de baisser (etat de fin
       que la bibliotheque n'emet pas toujours) bloque le recentrage
       pour de bon, et le livre reste de travers. Ici l'agitation
       s'estompe toute seule. */
    function enMouvement() {
      return Date.now() - derniereAgitation < 250;
    }

    /* On ne mesure PAS des positions a l'ecran — elles bougent avec le
       deplacement en cours. On mesure les deux MARGES, a gauche et a
       droite, entre le bord du bloc et les pages dessinees : ces
       valeurs-la sont prises dans le meme repere, donc insensibles au
       deplacement deja applique.

       Surtout, le resultat est RAMENE a l'une des trois seules
       positions possibles : une demi-page a gauche (couverture seule,
       dessinee a droite), zero (double page), une demi-page a droite
       (dos seul). Une mesure prise a un mauvais moment ne peut donc
       plus decaler le livre d'une valeur batarde : elle retombe sur la
       position juste la plus proche. */
    function mesurerDecalage() {
      var items = livre.querySelectorAll('.stf__item');
      if (!items.length) return null;

      var gauche = Infinity;
      var droite = -Infinity;
      var largeurPage = 0;

      for (var i = 0; i < items.length; i++) {
        if (getComputedStyle(items[i]).display === 'none') continue;
        var r = items[i].getBoundingClientRect();
        if (!r.width) continue;
        if (r.left < gauche) gauche = r.left;
        if (r.right > droite) droite = r.right;
        if (r.width > largeurPage) largeurPage = r.width;
      }
      if (gauche === Infinity || !largeurPage) return null;

      var cadre = livre.getBoundingClientRect();
      var brut = ((cadre.right - droite) - (gauche - cadre.left)) / 2;
      var demi = largeurPage / 2;

      if (brut < -demi / 2) return -Math.round(demi);
      if (brut > demi / 2) return Math.round(demi);
      return 0;
    }

    function appliquer(decalage, animer) {
      /* Mesure impossible (pages pas encore posees, onglet en
         arriere-plan) : on ne montre surtout pas le livre, il
         apparaitrait de travers. La surveillance repassera. */
      if (decalage === null) return;

      if (decalage === decalageApplique) {
        marquerPret();
        return;
      }
      decalageApplique = decalage;

      if (animer === false) {
        /* Au chargement : le livre doit etre deja en place a l'arrivee,
           pas glisser sous les yeux du visiteur. */
        livre.style.transition = 'none';
        livre.style.transform = 'translateX(' + decalage + 'px)';
        void livre.offsetWidth;
        livre.style.transition = '';
      } else {
        livre.style.transform = 'translateX(' + decalage + 'px)';
      }
      marquerPret();
    }

    /* Une mesure isolee peut tomber pendant que la bibliotheque remet
       ses pages en place. On en prend donc deux, espacees, et on
       n'applique que si elles disent la meme chose. */
    function recentrer(animer) {
      if (enMouvement()) {
        programmerRecentrage(animer, 260);
        return;
      }
      var premiere = mesurerDecalage();
      if (premiere === null) return;

      setTimeout(function () {
        if (enMouvement()) {
          programmerRecentrage(animer, 260);
          return;
        }
        var seconde = mesurerDecalage();
        if (seconde === null || seconde !== premiere) {
          programmerRecentrage(animer, 120);
          return;
        }
        appliquer(seconde, animer);
      }, 70);
    }

    function programmerRecentrage(animer, delai) {
      if (minuterieRecentrage) clearTimeout(minuterieRecentrage);
      minuterieRecentrage = setTimeout(function () {
        minuterieRecentrage = null;
        recentrer(animer);
      }, delai || 60);
    }

    /* Etats de la bibliotheque :
       - flipping   : tournage automatique, la double page s'ouvre pour
                      de bon -> on revient au centre pendant le mouvement
       - user_fold  : glissement a la souris, relachable sans rien tourner
       - fold_corner: simple survol du coin
       Les deux derniers ne doivent surtout pas deplacer le livre : c'est
       ce qui le faisait filer vers la droite au passage de la souris. */
    flip.on('changeState', function (event) {
      if (!event) return;

      if (event.data === 'flipping') {
        derniereAgitation = Date.now();
        if (decalageApplique !== 0) {
          decalageApplique = 0;
          livre.style.transform = 'translateX(0px)';
        }
      } else if (event.data === 'user_fold' || event.data === 'fold_corner') {
        derniereAgitation = Date.now();
      } else if (event.data === 'read') {
        programmerRecentrage(true, 120);
      }
    });

    flip.on('flip', function (event) {
      programmerRecentrage(true, 120);
      var ou = event && event.data;
      if (typeof ou !== 'number') {
        try { ou = flip.getCurrentPageIndex(); } catch (e) { ou = null; }
      }
      if (typeof ou === 'number') libererAutour(ou);
    });
    flip.on('changeOrientation', function () {
      programmerRecentrage(false, 80);
    });

    /* AU CHARGEMENT.
       StPageFlip attend sa propre frame pour poser ses pages, et la
       couverture n'a souvent pas fini de charger. Des rendez-vous fixes
       tombaient trop tot. On surveille donc jusqu'a ce que le livre soit
       place, avec un plafond de dix secondes : tant que la page est dans
       un onglet d'arriere-plan, les largeurs valent zero et il n'y a
       rien a mesurer. */
    var finSurveillance = Date.now() + 10000;

    function surveiller() {
      appliquer(mesurerDecalage(), false);
      if (decalageApplique === null && Date.now() < finSurveillance) {
        setTimeout(surveiller, 120);
      }
    }
    surveiller();

    window.addEventListener('load', function () {
      programmerRecentrage(false, 50);
    });

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) programmerRecentrage(false, 80);
    });

    window.addEventListener('resize', function () {
      publierHauteur(livre);
      programmerRecentrage(false, 150);
    });

    /* ON N'OUVRE PAS LE ROBINET D'UN SEUL COUP.
       Les pages masquees par StPageFlip ne declenchent pas le "lazy" :
       il faut les liberer nous-memes. La version precedente les
       liberait TOUTES ensemble, ce qui lancait une quinzaine de
       telechargements simultanes se disputant la bande passante : sur
       un telephone, aucune n'arrivait a temps et les pages restaient
       blanches. On libere donc une fenetre autour de la page lue, et
       on l'elargit a chaque tournage. */
    function libererAutour(index) {
      var debut = Math.max(0, index - 2);
      var fin = Math.min(pages.length - 1, index + 5);
      for (var i = debut; i <= fin; i++) {
        var img = pages[i].querySelector('.lookbook-book__image[loading="lazy"]');
        if (img) img.loading = 'eager';
      }
    }

    setTimeout(function () { libererAutour(0); }, 500);

    var agrandissement = creerAgrandissement(livre, flip, pages, recentrer, enMouvement);

    /* Aucun selecteur a l'ecran : on tourne les pages en cliquant
       ou en tirant le coin (gere par StPageFlip), et au clavier.
       Quand une page est agrandie, les fleches pilotent
       l'agrandissement et non plus le livre. */
    document.addEventListener('keydown', function (event) {
      if (agrandissement && agrandissement.estOuvert()) return;
      if (event.key === 'ArrowLeft') flip.flipPrev();
      if (event.key === 'ArrowRight') flip.flipNext();
    });
  }

  function attendre() {
    var livre = document.querySelector('[data-lookbook-book]');
    if (!livre) return;

    if (window.St && window.St.PageFlip) {
      demarrer(livre);
      return;
    }

    if (Date.now() - DEBUT > ATTENTE_MAX) {
      replier(livre);
      return;
    }

    setTimeout(attendre, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attendre);
  } else {
    attendre();
  }
})();
